module.exports = __webpack_public_path__ + "static/media/individuals-resource.c9e8f9b0.png";